var map = {
	"./en-au.json": [
		906820,
		6820
	],
	"./en-ca.json": [
		409866,
		9866
	],
	"./en-nz.json": [
		575910,
		5910
	],
	"./en-us.json": [
		284186,
		4186
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 703800;
module.exports = webpackAsyncContext;